<template>
  <div class="breadcrumbContainer" :style="getContainerStyle">
    <div
      v-for="(item, index) in sourceData"
      :key="index"
      class="breadcrumb_item"
      @click="breadCrumbsItemClickHandle(item)"
    >
      <template v-if="!item.isHide">
        <span :style="getTextStyle(item.path)">{{ item.label }}</span>
        <span class="icon" v-if="separatorType === 'str'" :style="getStrStyle">/</span>
        <template v-else-if="separatorType === 'icon'">
          <cxIcon
            class="icon"
            v-if="iconType === 'icon' && iconSrc"
            :options="options"
            :iconStyle="getIconStyle"
          ></cxIcon>
          <img class="icon" v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { isSsrPage, findCurrentComponentPathInLayoutByRectId, replaceUrlParam } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
export default {
  mixins: [eventMixin, subPageEventMixin],
  name: "cxBreadCrumbs",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isNav: false,
      appId: "",
      subPage: {}
    }
  },
  mounted() {
    this.appId = this.$store.state.states?.getDataPageIds?.appId
    if (this.appId && (this.pageType === "listPage" || this.pageType === "detailPage")) {
      let subPageSetting = window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix)
      this.subPage = (subPageSetting && JSON.parse(subPageSetting)) || {}
      this.isNav = this.subPage?.nav
    }
    const bigScreen = this.request_prefix === "bigScreen" || this.isBigScreenPreview()
    if (!bigScreen && !this.options.hasOwnProperty("isSystemComponent")) {
      // 面包屑支持上传和收藏 兼容以前的样式
      const menuName = this.request_prefix === "stage" ? 'menu' : 'appMenu'
      const moduleTypes = this.$store.state[menuName]?.menu?.moduleTypes
      const componentTypeId = moduleTypes?.find(item => item.name === '面包屑')?.encId
      this.$changeOptionsEV(
        [true, true, true, true, componentTypeId],
        ["isSystemComponent", "isDefaultComponent", "isCustomComponent", "isIndependenceComponent", 'componentTypeId'], false, null, this.myid, true)
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    separatorType() {
      return this.options.separatorType
    },
    sourceData() {
      // let isSet = this.options?.crumbsSetting && (this.options.crumbsSetting?.zIndexType === 1 || this.options.crumbsSetting?.syncListPage)
      let sourceData = this.setSourceData()
      // 判断文字是否需要省略
      if (!this.options.contentHasLimit) {
        // let sourceData = JSON.parse(JSON.stringify(this.options.sourceData))
        // isSet ? sourceData = this.setSourceData(sourceData) : ""
        // this.isNav ? sourceData[1].isHide = true : ""
        return sourceData
      }
      // let sourceData = JSON.parse(JSON.stringify(this.options.sourceData))
      let textLimitWords = this.options.textLimitWords
      let textOverflowEllipsis = this.options.textOverflowEllipsis
      sourceData.forEach(item => {
        if (!item || !item.label) {
          return
        }
        if (item.label.length > textLimitWords) {
          if (!textOverflowEllipsis) {
            item.label = item.label.slice(0, textLimitWords)
          } else {
            item.label = item.label.slice(0, textLimitWords) + "..."
          }
        }
      })
      // isSet ? sourceData = this.setSourceData(sourceData) : ""
      // this.isNav ? sourceData[1].isHide = true : ""
      return sourceData
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getStrStyle() {
      return {
        margin: `0 ${this.options.iconMargin}px 0 ${this.options.iconMargin}px`
      }
    },
    getIconStyle() {
      return {
        display: "inline-block",
        "--color": this.$parseColor(this.options.iconColor,{isThemeColor: this.options.iconColorIsThemeColor}),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: `0 ${this.options.iconMargin}px 0 ${this.options.iconMargin}px`
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconWidth + "px",
        margin: this.getMargin,
        margin: `0 ${this.options.iconMargin}px 0 ${this.options.iconMargin}px`
      }
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            if (bg.data.stops.length > 0) {
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            if (bg.data.stops.length > 0) {
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getContainerStyle() {
      if (this.options) {
        let borderW = ""
        this.checkAndSetVal(this.options, "borderWidth", "borderWidth", 1)
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        const {
          hoverIsSameActive,
          activeLetterSpacingType,
          hoverLetterSpacingType,
          activeLetterSpacing,
          hoverLetterSpacing,
          activeFontStyle,
          hoverFontStyle,
          activeFontFamily,
          hoverFontFamily,
          activeTextIsThemeColor,
          activeColor,
          hoverTextIsThemeColor,
          hoverColor,
          activeFontSize,
          hoverFontSize,
          activeFontWeight,
          hoverFontWeight,
          activeTextDecoration,
          hoverTextDecoration,
          activeLineHeight,
          hoverLineHeight,
        } = this.options
        let actualLineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight/100 * this.options.fontSize) : this.options.lineHeight
        let actualActiveLineHeight = this.options.activeLineHeightType === '%' ? (this.options.activeLineHeight/100 * this.options.activeFontSize) : this.options.activeLineHeight
        let actualHoverLineHeight = this.options.hoverLineHeightType === '%' ? (this.options.hoverLineHeight/100 * this.options.hoverFontSize) : this.options.hoverLineHeight
        let lineHeight = this.options.height
        if(this.options.heightType === "自动"){
          lineHeight = `${actualLineHeight}px`
        }else if(this.options.heightType === undefined){
          lineHeight = `${this.options.lineHeight}px`
        }else{
          lineHeight = `${this.options.height}px`
        }
        let thisStyle = {
          padding: this.getPaddingStyle,
          height: "100%",
          lineHeight: lineHeight,
          // "letter-spacing": this.options.letterSpacing + "px",
          "letter-spacing":
            this.options.letterSpacingType === "%"
              ? this.options.letterSpacing / 100 + "em"
              : this.options.letterSpacing + "px",
          "font-style": `${this.options.fontStyle}`,
          "font-family": this.options.fontFamily,
          opacity: this.options.opacity,
          color: this.$parseColor(this.options.color,{isThemeColor: this.options.textIsThemeColor}),
          "font-size": this.options.fontSize + "px",
          "font-weight": this.options.fontWeight,
          "text-decoration": this.options.textDecoration,
          transform: "rotate(" + this.options.rotate + "deg)",
          "border-style": this.options.borderStyle,
          "border-color": this.$parseColor(this.options.borderColor,{isThemeColor: this.options.borderIsThemeColor}),
          "border-width": borderW,
          "box-shadow": this.boxShadowStyle,
          "border-top-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopLeftRadius + "px",
          "border-top-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopRightRadius + "px",
          "border-bottom-left-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius":
            this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomRightRadius + "px",
          "--hoverLetterSpacing": hoverIsSameActive
            ? activeLetterSpacingType === "%"
              ? activeLetterSpacing / 100 + "em"
              : activeLetterSpacing + "px"
            : hoverLetterSpacingType === "%"
            ? hoverLetterSpacing / 100 + "em"
            : hoverLetterSpacing + "px",
          "--hoverFontStyle": hoverIsSameActive ? activeFontStyle : hoverFontStyle,
          "--hoverFontFamily": hoverIsSameActive ? activeFontFamily : hoverFontFamily,
          "--hoverColor": hoverIsSameActive ? this.$parseColor(activeColor,{isThemeColor:activeTextIsThemeColor}) :
              this.$parseColor(hoverColor,{isThemeColor:hoverTextIsThemeColor}),
          "--hoverFontSize": `${hoverIsSameActive ? activeFontSize : hoverFontSize}px`,
          "--hoverFontWeight": hoverIsSameActive ? activeFontWeight : hoverFontWeight,
          "--hoverTextDecoration": hoverIsSameActive ? activeTextDecoration : hoverTextDecoration,
          "--hoverLineHeight": `${hoverIsSameActive ? actualActiveLineHeight : actualHoverLineHeight}px`
        }
        return {
          ...this.bgStyle,
          ...thisStyle
        }
      } else return null
    },
    getTextStyle() {
      return function (path) {
        if (!path) {
          return {
            "letter-spacing":
              this.options.activeLetterSpacingType === "%"
                ? this.options.activeLetterSpacing / 100 + "em"
                : this.options.activeLetterSpacing + "px",
            "font-style": `${this.options.activeFontStyle}`,
            "font-family": this.options.activeFontFamily,
            color: this.$parseColor(this.options.activeColor,{isThemeColor: this.options.activeTextIsThemeColor}),
            "font-size": this.options.activeFontSize + "px",
            "font-weight": this.options.activeFontWeight,
            "text-decoration": this.options.activeTextDecoration,
            "line-height": this.options.activeLineHeight + "px"
          }
        }
      }
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    }
  },
  methods: {
    setSourceData() {
      let isSet = this.options?.crumbsSetting && (this.options.crumbsSetting?.zIndexType === 1 || this.options.crumbsSetting?.syncListPage)
      let sourceData = JSON.parse(JSON.stringify(this.options.sourceData))
      let equalHomeIndex = -1 // 平级页面首页应名称所在位置
      let homeIndex = 0 // 当前首页名称所在位置
      let appIndex = 1 // 应用名称所在位置
      if (sourceData[0]?.value === "equalPageHome") {// 多加一个平级页面首页
        equalHomeIndex = 0
        homeIndex = 1
        appIndex = 2
        // 修改默认值 默认显示平级页面的大首页
        sourceData[0].isHide = false
        sourceData[homeIndex].isHide = true
      }
      this.isNav ? sourceData[appIndex].isHide = true : "" // 导航的应用名称不显示
      if (!isSet) return sourceData // 不是自定义或者同步列表页样式 不用做以下处理
      let newData = sourceData
      const options = JSON.parse(JSON.stringify(this.options))
      let crumbsSetting = (options.crumbsSetting && JSON.parse(JSON.stringify(options.crumbsSetting))) || {}
      if (this.pageType === "listPage" || this.pageType === "detailPage") {
        // 每次改变了需要重新获取，避免刷新页面才能看到更新
        this.appId = this.$store.state.states?.getDataPageIds?.appId
        let subPageSetting = window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix)
        this.subPage = (subPageSetting && JSON.parse(subPageSetting)) || {}
      }
      if (crumbsSetting.syncListPage && this.subPage) {
        // 与列表页面包屑一致
        crumbsSetting = this.subPage?.crumbsSetting
      }
      if (crumbsSetting?.zIndexType !== 1) return sourceData // 不是自定义
      console.log('crumbsSetting :>>', crumbsSetting);
      let { showHomeName, homeName, homeNameType, showAppName, appName, appNameType, showClassifyName, classifyName, classifyNameType, showDataName, dataName, dataNameType, showEqualHomeName, equalHomeNameType, equalHomeName } = crumbsSetting
      // 正常子页面的首页默认显示，平级页面的子页面的首页默认隐藏
      newData[homeIndex].isHide = showHomeName === undefined ? sourceData[0]?.value === "equalPageHome" ? true : false : !showHomeName
      if (homeNameType === 1 && crumbsSetting.hasOwnProperty("homeName")) {// 首页名称
        newData[homeIndex].label = homeName
      }
      newData[appIndex].isHide = showAppName === undefined ? false : !showAppName
      if (appNameType === 1 && crumbsSetting.hasOwnProperty("appName")) {// 自定义应用名称
        newData[appIndex].label = appName
      }
      if (equalHomeIndex !== -1) {
        newData[equalHomeIndex].isHide = showEqualHomeName === undefined ? false : !showEqualHomeName
        if (equalHomeNameType === 1 && crumbsSetting.hasOwnProperty("equalHomeName")) {// 自定义应用名称
          newData[equalHomeIndex].label = equalHomeName
        }
      }
      const index = this.pageType === "detailPage" ? newData.length - 1 : -1
      newData.forEach((it, idx) => {// 除了首页 应用名称和数据名称，其他的就是分类
        if (idx !== homeIndex && idx !== appIndex && idx !== index && idx !== equalHomeIndex ) {
          newData[idx].isHide = showClassifyName === undefined ? false : !showClassifyName
          if (!newData[idx].isHide && classifyNameType === 1 && crumbsSetting.hasOwnProperty("classifyName")) {// 自定义分类显示层级
            if (idx < classifyName + appIndex + 1) {// 显示几级分类
              newData[idx].isHide = false
            } else if (idx > classifyName + appIndex) {// 隐藏之后的分类
              newData[idx].isHide = true
            }
          }
        }
      })
      if (index !== -1) {
        // 数据名称
        newData[index].isHide = showDataName === undefined ? false : !showDataName
        if (dataNameType === 1 && crumbsSetting.hasOwnProperty("dataName")) {
          newData[index].label = dataName
        }
      }
      this.isNav ? sourceData[appIndex].isHide = true : "" // 导航的应用名称不显示
      console.log('newData :>>', newData);
      return newData
    },
    checkAndSetVal(opt, key, optname, val) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, this.myid)
        return val
      }
    },
    breadCrumbsItemClickHandle(data) {
      console.log("data", data)
      if (data.value) {
        // 说明在当前页请求不同分类数据
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          container_id: 0,
          directionIndex: 2, // 需要改变多级导航的值
          elementInAutoLayoutId: undefined,
          elementInLayoutId: 0,
          rect_id: 9999,
          option_name: "value",
          option_val: data.value
        })
      }
    },
    /**
     * 通过业务插件初始化面包屑数据
     * @param {*} showBreadCrumbs 是否显示面包屑
     * @param {*} breadCrumbsData 面包屑数据
     * @param {*} restUrl 分类数据
     * @returns
     */
    initListPageBreadCrumbsData(showBreadCrumbs, breadCrumbsData, restUrl) {
      console.log("initDetailPageBreadCrumbsData")
      sessionStorage.setItem("hasBreadCrumbs", "1")
      const layout = this.$store.state[self.request_prefix].page.pageLayoutList
      const pageLayoutId = findCurrentComponentPathInLayoutByRectId(layout, this.myid.rect_id).join("_")
      // 初始化breadCrumbs面包屑组件
      if (!showBreadCrumbs) {
        this.$changeOptionsEV(0, "opacity", false, null, this.myid, true)
        this.$changeOptionsEV(
          false,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        return
      } else {
        this.$changeOptionsEV(100, "opacity", false, null, this.myid, true)
        this.$changeOptionsEV(
          true,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
      }
      let homePageName = ""
      let equalPageHomeName = ""
      let subPageName = this.$store.state.states.subPageName
      const hasEqualPage = this.$store.state?.states?.getDataPageIds?.hasEqualPage
      if (breadCrumbsData) {
        homePageName = breadCrumbsData.data?.data?.pageName //修改了接口，当前页面名称返回到获取面包屑接口中
        equalPageHomeName = breadCrumbsData.data?.data?.indexPageName // 平级页面的首页名称
        let homeIndex = 0 // 当前首页名称所在位置
        let appIndex = 1 // 应用名称所在位置
        // 判断是初始化还是点击多级导航后的数据联动
        const sourceData = JSON.parse(JSON.stringify(this.options.sourceData))
        if (sourceData[0]?.value === "equalPageHome") {// 多加一个平级页面首页
          homeIndex = 1
          appIndex = 2
        }
        sourceData.splice(appIndex + 1) // 删除除前两个元素外的其他元素
        const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
          label: item.name,
          value: item.id
        }))
        sourceData.push(...crumbsData)
        sourceData[homeIndex].label = homePageName ? homePageName : "首页"
        sourceData[appIndex].label = subPageName ? subPageName : "图文"
        if (hasEqualPage && sourceData[0]?.value !== "equalPageHome") {// 平级页面的子页面
          sourceData.unshift({
            label: equalPageHomeName ? equalPageHomeName : "首页",
            value: "equalPageHome",
            path: "/"
          })
        }
        this.$changeOptionsEV(sourceData, "sourceData", false, null, this.myid, true)
      } else {
        const homePageId = this.$store.state[this.request_prefix].page.homePageId
        const newUrl = replaceUrlParam(window.location.href, "p", homePageId)
        let defaultParam = restUrl.data.data.generalDataTypes[0] // 默认选中第一个分类，数据可能会没有分类
        // 现在没有地方取到应用名称，先暂时写死应用名称
        const sourceData = [
          {
            label: homePageName ? homePageName : "首页",
            path: newUrl
          },
          {
            label: subPageName ? subPageName : "图文"
          },
          {
            label: defaultParam?.name,
            value: defaultParam?.publicId
          }
        ]
        this.$changeOptionsEV(sourceData, "sourceData", false, null, this.myid, true)
      }
    },
    initDetailPageBreadCrumbsData(showBreadCrumbs, breadCrumbsData, homePageUrl, listPageUrl) {
      console.log("initDetailPageBreadCrumbsData")
      sessionStorage.setItem("hasBreadCrumbs", "1")
      if (showBreadCrumbs) {
        let homePageName = ""
        let equalPageHomeName = ""
        let subPageName = window.localStorage.getItem("appName")
        const hasEqualPage = this.$store.state?.states?.getDataPageIds?.hasEqualPage
        if (breadCrumbsData) {
          homePageName = breadCrumbsData.data?.data?.pageName //修改了接口，当前页面名称返回到获取面包屑接口中
          equalPageHomeName = breadCrumbsData.data?.data?.indexPageName // 平级页面的首页名称
          // 判断是初始化还是点击多级导航后的数据联动
          const sourceData = [
            {
              label: homePageName ? homePageName : "首页",
              path: homePageUrl
            },
            {
              label: subPageName ? subPageName : "图文",
              path: listPageUrl
            }
          ]
          const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
            label: item.name,
            value: item.id,
            path: listPageUrl
          }))
          if (hasEqualPage && sourceData[0]?.value !== "equalPageHome") {// 平级页面的子页面
            sourceData.unshift({
              label: equalPageHomeName,
              value: "equalPageHome",
              path: "/"
            })
          }
          sourceData.push(...crumbsData)
          // 导航菜单的详情页面包屑不显示名称
          // if (this.appType === "cxNavMenu") {
          //   // 删掉第二个元素
          //   sourceData.splice(1, 1)
          // }
          // 获取当前标题
          const detailData = JSON.parse(window.localStorage.getItem("detailData"))
          // 数据源为表单时 不知道哪一项为标题
          let titleInKey = detailData
            ? Object.keys(detailData[0]).find(key => {
                if (detailData[0][key]?.key?.includes("名称") || detailData[0][key]?.key?.includes("标题")) {
                  return key
                }
              })
            : -1
          titleInKey = titleInKey === -1 ? 1 : titleInKey
          const title = detailData[0][titleInKey]?.value
          sourceData.push({ label: title })
          this.$changeOptionsEV(sourceData, "sourceData", false, null, this.myid, true)
        }
      } else {
        this.$changeOptionsEV(0, "opacity", false, null, this.myid, true)
      }
    },
    /**
     * 通过新版业务插件初始化面包屑数据
     * @param {*} plugin // 业务插件对象
     * @returns
     */
    async initSubPageBreadCrumbsData(plugin) {
      console.log("initSubPageBreadCrumbsData")
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayoutId = findCurrentComponentPathInLayoutByRectId(layout, this.myid.rect_id).join("_")
      // 初始化breadCrumbs面包屑组件
      if (!plugin.showBreadCrumbs) {
        this.$changeOptionsEV(0, "opacity", false, null, this.myid, true)
        this.$changeOptionsEV(
          false,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
        return
      } else {
        this.$changeOptionsEV(100, "opacity", false, null, this.myid, true)
        this.$changeOptionsEV(
          true,
          "isShow",
          false,
          null,
          {
            pageLayoutId: pageLayoutId
          },
          true
        )
      }
      let homePageName = ""
      let equalPageHomeName = ""
      let subPageName = this.$store.state.states.subPageName
      const hasEqualPage = this.$store.state?.states?.getDataPageIds?.hasEqualPage
      let breadCrumbsData = await this.$API.queryCrumbData({
        typeId: plugin.params.t ? plugin.params.t : 0,
        e: plugin.engineId
      })
      if (breadCrumbsData) {
        homePageName = breadCrumbsData.data?.data?.pageName //修改了接口，当前页面名称返回到获取面包屑接口中
        equalPageHomeName = breadCrumbsData.data?.data?.indexPageName // 平级页面的首页名称
        let homeIndex = 0 // 当前首页名称所在位置
        let appIndex = 1 // 应用名称所在位置
        // 判断是初始化还是点击多级导航后的数据联动
        const sourceData = JSON.parse(JSON.stringify(this.options.sourceData))
        if (sourceData[0]?.value === "equalPageHome") {// 多加一个平级页面首页
          homeIndex = 1
          appIndex = 2
        }
        sourceData.splice(appIndex + 1) // 删除除前两个元素外的其他元素
        const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
          label: item.name,
          value: item.id
        }))
        sourceData.push(...crumbsData)
        sourceData[homeIndex].label = homePageName ? homePageName : "首页"
        sourceData[appIndex].label = subPageName ? subPageName : "图文"
        sourceData[appIndex].path = ""
        if (hasEqualPage && sourceData[0]?.value !== "equalPageHome") {// 平级页面的子页面
          sourceData.unshift({
            label: equalPageHomeName ? equalPageHomeName : "首页",
            value: "equalPageHome",
            path: "/"
          })
        }
        this.$changeOptionsEV(sourceData, "sourceData", false, null, this.myid, true)
      } else {
        const homePageId = this.$store.state[this.request_prefix].page.homePageId
        const newUrl = replaceUrlParam(window.location.href, "p", homePageId)
        let defaultParam = plugin.restUrl.data.data.generalDataTypes[0] // 默认选中第一个分类，数据可能会没有分类
        // 现在没有地方取到应用名称，先暂时写死应用名称
        const sourceData = [
          {
            label: homePageName ? homePageName : "首页",
            path: newUrl
          },
          {
            label: subPageName ? subPageName : "图文"
          },
          {
            label: defaultParam?.name,
            value: defaultParam?.publicId
          }
        ]
        this.$changeOptionsEV(sourceData, "sourceData", false, null, this.myid, true)
      }
    },
  }
}
</script>
<style scoped>
.breadcrumbContainer {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
}
.breadcrumb_item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.breadcrumb_item span:first-child:hover {
  letter-spacing: var(--hoverLetterSpacing);
  font-style: var(--hoverFontStyle);
  font-family: var(--hoverFontFamily);
  color: var(--hoverColor);
  font-size: var(--hoverFontSize);
  font-weight: var(--hoverFontWeight);
  text-decoration: var(--hoverTextDecoration);
  line-height: var(--hoverLineHeight);
}

::v-deep.breadcrumb_item svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}

::v-deep.breadcrumb_item svg * {
  stroke: var(--color);
}
.breadcrumb_item:last-child > .icon {
  display: none !important;
}
</style>
